import { useEffect, useState } from "react";
import "./App.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import Calling from "./api/Calling";
import { ToastContainer } from "react-toastify";
import Navbar1 from "./components/Navbar/Navbar1";
import Login from "./admin/Login/Login";
import Page404 from "./components/Page404";
import Logout from "./admin/Login/Logout";
import Error from "./admin/Login/Error";
import Home from "./admin/Home";
import NewPw from "./admin/Login/NewPw";
import AllProfile from "./admin/Profile/AllProfile";
import { useDispatch, useSelector } from "react-redux";
import { addProfile } from "./redux/slices/profileSlices";
import AddAds from "./admin/ads/AddAds";
import ViewAds from "./admin/ads/ViewAds";

function App() {
  const [isAuthorized, setIsAuthorized] = useState(null);
  const navigate = useNavigate();
  const profile = useSelector((state) => state.profile);
  const dispatch = useDispatch();
  const handleLoginStatusChange = (status) => {
    if (status) {
      setIsAuthorized(true);
    }
  };

  const handleLogout = () => {
    setIsAuthorized(false);
    localStorage.removeItem("admin_ads_manager");
    navigate("/app-admin/panel/login");
  };

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const adminToken = localStorage.getItem("admin_ads_manager");
        if (!adminToken) {
          setIsAuthorized(false);
          return;
        }
        const resp = await Calling.AdminAuthCheck();
        setIsAuthorized(resp.status);
      } catch (error) {
        console.error("Authorization error:", error);
        setIsAuthorized(false);
      }
    };
    const getProfile = async () => {
      try {
        const id = localStorage.getItem("profile");
        if (!id) {
          setIsAuthorized(false);
          return;
        }
        const resp = await Calling.getProfile(id);
        if (resp.status) {
          setIsAuthorized(true);
          dispatch(addProfile(resp.data));
        } else {
          navigate("/Logout");
        }
      } catch (error) {
        console.error("Authorization error:", error);
        setIsAuthorized(false);
      }
    };

    checkAuthorization();
    if (localStorage.getItem("profile")) {
      getProfile();
    }
  }, []);

  if (isAuthorized === null) {
    return <div className="text-white p-4">Checking authorization...</div>;
  }

  return (
    <div className="flex roboto-regular bg-main-th">
      <ToastContainer />
      {isAuthorized && profile._id && <Navbar1 />}
      <div className="flex ml-w-15 w-[100%]">
        <Routes>
          {isAuthorized ? (
            <>
              <Route path="/all/profile" element={<AllProfile />} />
              <Route path="/manage/changePw/" element={<NewPw />} />
              <Route
                path="/Logout"
                element={<Logout onLogout={handleLogout} />}
              />
              {profile._id && (
                <>
                  <Route path="/" element={<Home />} />
                  <Route path="Error" element={<Error />} />

                  {/* Ads */}
                  <Route path="/Ads/add" element={<AddAds />} />
                  <Route path="/Ads/view/:id" element={<ViewAds />} />

                  {/* Views Dashbord */}
                  <Route path="/:id" element={<Home />} />

                  <Route path="*" element={<Page404 />} />
                </>
              )}
              {!profile._id && <Route path="*" element={<Page404 />} />}
            </>
          ) : (
            <>
              <Route
                path="/app-admin/panel/login"
                element={<Login onLogin={handleLoginStatusChange} />}
              />
              <Route path="*" element={<Page404 />} />
            </>
          )}
        </Routes>
      </div>
    </div>
  );
}

export default App;
